import '../util/array.prototype';

export function toSentence(array: any[], fieldName?: string, conjunction: string = 'and'): string {
  array = Array.isArray(array) ? array : [array];
  const items = fieldName ? array.flatMap(item => item[fieldName]) : array;

  return items
    .join(', ')
    .replace(/, ([^,]+)$/, ' ' + conjunction + ' $1');
}



// WEBPACK FOOTER //
// ./src/gs-core/common/convert/toSentence.ts